import React, { useState } from 'react';
import { ReduxState, Tokens } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { Button, TextField } from '@material-ui/core';
import './forgetpassword.style.scss';
import { useHistory } from 'react-router-dom';
import { post } from 'scripts/api';
import { API } from 'data';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';

const Forget: React.FC<ConnectedProps<typeof connector>> = function (props: ConnectedProps<typeof connector>) {
    const lang = props.lang.signin.forgetPass;
    const [email, setEmail] = useState<string | undefined>(undefined);
    const history = useHistory<any>();
    const [load, setLoad] = useState(false);

    function onClickHandler() {
        if (email) {
            setLoad(true);
            post<Tokens>(API.register.forgetPassword, { email_or_phone: email })
                .then(() => toast.success(lang.success))
                .catch((res) => {
                    if (res.status >= 500) toast.error(props.lang.serverErr);
                    else if (res.status >= 400) toast.error(lang.error);
                    else toast.error(props.lang.unknownErr);
                })
                .finally(() => setLoad(false));
        }
    }

    return (
        <div className="sign-in-forget">
            <div className="header">
                <i onClick={() => history.goBack()} className="material-icons">
                    arrow_forward
                </i>
                <p className="header-text">{lang.forget}</p>
            </div>
            <div className="signin-forget-password ">
                <div className="top">
                    <p>{lang.header}</p>
                </div>
                <TextField
                    className="username"
                    id="input-with-icon-textfield"
                    InputProps={{
                        startAdornment: <i className="material-icons icon">person</i>,
                    }}
                    autoComplete="false"
                    onChange={(e) => setEmail(e.target.value)}
                />
                <div className="button-div">
                    <Button
                        onClick={onClickHandler}
                        disabled={!email || load}
                        className="enter-button"
                        variant="contained"
                        color="primary"
                        disableElevation
                    >
                        {load ? <Spinner animation="border" /> : lang.send}
                    </Button>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    dir: state.direction,
    lang: state.lang,
});

const connector = connect(mapStateToProps);
export default connector(Forget);
